<template>
  <div>
    <PortadaScroll/>
    <div class="accesos-directos">
      <TarjetaAccesoDirecto
        :titulo="'Galería fotográfica'"
        :to="'/galeria'"
        :src="require('@/assets/img/accesos-directos/img_galeria_portada.jpg')"
      />
      <TarjetaAccesoDirecto
        :titulo="'Diagnóstico'"
        :to="'/diagnostico'"
        :src="require('@/assets/img/accesos-directos/img_diagnostico_portada.jpg')"
      />
      <TarjetaAccesoDirecto
        :titulo="'Propuesta'"
        :to="'/propuesta'"
        :src="require('@/assets/img/accesos-directos/img_propuesta_portada.jpg')"
      />
      <TarjetaAccesoDirecto
        :titulo="'Productos de investigación'"
        :to="'/productos-de-investigacion'"
        :src="require('@/assets/img/accesos-directos/img_prodInvest_portada.jpg')"
      />
    </div>
  </div>
</template>

<script>
import TarjetaAccesoDirecto from "@/components/TarjetaAccesoDirecto.vue"
import PortadaScroll from "@/components/componentes-texcoco/PortadaScroll.vue"
import { mostrarLoader } from '@/components/_utils.js'

export default {
  name: 'MainHeader',
  components: {
    PortadaScroll,
    TarjetaAccesoDirecto
  },
  mounted() {
    mostrarLoader()
  },
};
</script>
<style lang="scss">
div.accesos-directos{
  padding: 0 16px;
  margin: 80px auto;
  max-width: 1080px;
  display: flex;
  flex-wrap: nowrap;
  justify-content: center;
  gap: 24px;
  @media screen and (max-width: map-get($media-queries-limit, "mobile")) {
    flex-wrap: wrap;
      margin: 80px auto 100px auto;

  }
}
</style>
